import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CommoditiesEditFormFields } from "web_myplann/Portfolio/Forms/CommoditiesForm/CommoditiesEditFormFields";
import { useEditCommoditiesForm } from "web_myplann/Portfolio/Forms/CommoditiesForm/useEditCommoditiesForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type EditCommoditiesFormProps = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const EditCommoditiesForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: EditCommoditiesFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending, leaveConfirmation } =
		useEditCommoditiesForm({
			portfolioId,
			portfolio,
			detailRoute,
		});

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.EditPortfolio.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
			leaveConfirmation={leaveConfirmation}
		>
			<CommoditiesEditFormFields
				control={form.control}
				disableKeyFields={!portfolio.allowKeyPropertiesEditByClient}
			/>
		</PortfolioFormShell>
	);
};
